import { gql } from 'apollo-angular';

export const RemoveTagDocument = gql`
  mutation removeTags($tagId: Int!) {
    removeTags(tagId: $tagId)
  }
`;
